<div class="modal solid open">
  <div (click)="close()" class="miniClose cancel icon-HamburgerAppClose"></div>
  @if (endpoint) {
    <div matTooltipPosition="above" matTooltip="{{ endpointName + ' Dial logs' }}" tooltipZIndex="1000" class="title">{{ endpointName + ' Dial Logs' | truncate: 60 }}</div>
  }
  @if (service) {
    <div matTooltipPosition="above" matTooltip="{{ serviceName + ' Dial logs' }}" tooltipZIndex="1000" class="title">{{ serviceName + ' Dial Logs' | truncate: 60}}</div>
  }
  @if (isLoading) {
    <app-loading-indicator
      [isLoading]="isLoading"
      class="load-indicator"
      id="dialLogsPage"
    ></app-loading-indicator>
  }

  <div class="area data-table" id="ItemsArea">
    @if (items.length >= 0 || filterHasChanged) {
      <app-data-table
        [tableId]="'dial-logs'"
        [columnDefinitions]="columnDefs"
        [rowData]="items"
        [columnFilters]="columnFilters"
        [isTimeSearchAvailable]="true"
        [isNotDialLogs]="false"
        (gridReady)="onGridReady($event)"
        [filterChanged]="filterChanged.bind(this)"
        pagination="true"
        paginationPageSize="30"
        [newStartTime]="newStartTime"
        [newEndTime]="newEndTime"
        >
      </app-data-table>
    }
  </div>
</div>
